module.exports = __webpack_public_path__ + "img/login_biaoti8.b2967d64.png";